import axios from 'axios'
// import axiosRetry from 'axios-retry'

const domain = window.location.hostname.split('.').slice(-2).join('.')

const requestTimestamp = config => {
  config.headers['X-Request-Timestamp'] = Math.floor(Date.now() / 1000).toString()
  return config
}

const AUTH_URL = `https://auth.${domain}/api/`

const AUTH = axios.create({
  baseURL: AUTH_URL,
  withCredentials: true,
  withXSRFToken: true,
})

AUTH.interceptors.request.use(requestTimestamp)

const API_URL = `https://api.${domain}/api/`

const API = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  withXSRFToken: true,
})

API.interceptors.request.use(requestTimestamp)

const LOGOUT = axios.create({
  baseURL: `https://api.${domain}/`,
  withCredentials: true,
  withXSRFToken: true,
})

LOGOUT.interceptors.request.use(requestTimestamp)

const LOGIN_URL = `https://app.${domain}/login`

// Axios Retry gets stuck in an infinite loop
// axiosRetry(API, { retries: 2, retryDelay: axiosRetry.exponentialDelay })

export { domain, AUTH, AUTH_URL, API, API_URL, LOGOUT, LOGIN_URL }
